import { apiClient } from '../client'
import { TodoApi } from '../generated'

export const todoApi = new TodoApi(undefined, '', apiClient)
